function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon",
  d: "M474.864,5355.771l-1.612-1.332C467.05,5349,463,5345.083,463,5340.274a7.221,7.221,0,0,1,7.322-7.275,7.9,7.9,0,0,1,5.178,1.976,7.908,7.908,0,0,1,5.178-1.976,7.221,7.221,0,0,1,7.323,7.275c0,4.807-4.05,8.722-10.229,14.146l-1.635,1.351a1,1,0,0,1-1.273,0Zm-9.864-15.5c0,3.955,3.957,7.736,9.549,12.643l.95.785.975-.8c5.568-4.889,9.526-8.67,9.526-12.625a5.242,5.242,0,0,0-5.323-5.274,5.96,5.96,0,0,0-4.417,2.045,1.034,1.034,0,0,1-1.522,0,5.956,5.956,0,0,0-4.417-2.045A5.241,5.241,0,0,0,465,5340.274Zm1.247.32a4.192,4.192,0,0,1,4.249-4.225,1,1,0,1,1,0,2,2.189,2.189,0,0,0-2.249,2.225,1,1,0,0,1-2,0Z",
  transform: "translate(-463 -5333)",
  fill: "#383a3e"
});

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.d7fd5edb.svg";
export { ForwardRef as ReactComponent };